import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Page, Drawer } from '../../components';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setLoading } from '../../store/portal/portalActions';
import { MyEventModel } from '../../types';
import { EventCard } from '../../components/events/EventCard';
import { LoginForm } from '../../components/Auth';
import { fetchAllMyEvents } from '../../store/myEvents/myEventActions';
import { validateLogon } from '../../utils/auth';

export const MyEvents = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const [rtPortal, rtUser, rtMyEvents] = useAppSelector(s => [s.portal, s.user, s.myEvent]);

  const [width, setWidth] = useState<number>(0);
  const [showLogin, setShowLogin] = useState<boolean>(false);

  useEffect(() => {
    console.log('in myevent');
    (async () => {
      if (!(await validateLogon(rtUser))) {
        //setShowLogin(true);
        navigation.navigate('login');
      } else {
        if (!rtMyEvents.loaded) {
          fetchData();
        }
      }
    })();

    return () => {
      console.log('unmount my event');
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (await validateLogon(rtUser)) {
        fetchData();
      }
    })();
    if (rtUser.loginStatus) {
      fetchData();
    }
  }, [rtUser]);

  useEffect(() => {
    if (rtMyEvents.loaded) dispatch(setLoading(false, 'MyEvent'));
  }, [rtMyEvents]);

  useEffect(() => {
    if (rtPortal.isSmallScreen) {
      setWidth(rtPortal.width - 2 * 16);
    } else {
      if (['md', 'lg'].includes(rtPortal.breakpoint)) {
        setWidth(rtPortal.width - 2 * 8);
      } else {
        setWidth(rtPortal.width - 2 * 8);
      }
    }
  }, [rtPortal.width]);

  const fetchData = () => {
    dispatch(setLoading(true, 'MyEvent - fetch'));
    // Setting up data
    // Get master event data from API
    dispatch(
      fetchAllMyEvents({
        limit: 30,
        searchParam: {},
        countToGet: 100,
      }),
    );
  };

  return (
    <Page title={'My Events'}>
      <View style={[rtPortal.isSmallScreen ? homeStyle.containerSm : homeStyle.containerMd, { width: width }]}>
        {rtMyEvents.allEvents.map((event: MyEventModel, i: number) => {
          return <EventCard key={i} event={event.event} />;
        })}
      </View>
      <Drawer id="myevent.login" visible={showLogin} type="custom" onClose={() => null}>
        <LoginForm onClose={() => setShowLogin(false)} navigation={navigation} />
      </Drawer>
    </Page>
  );
};

const homeStyle = StyleSheet.create({
  containerMd: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -8,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  containerSm: {
    flex: 1,
    flexDirection: 'column',
    marginHorizontal: -8,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
});
